<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>{{ $t('components.payout.created_date') }}</th>
            <th>{{ $t('components.payout.client') }}</th>
            <th>{{ $t('components.payout.description') }}</th>
            <th>{{ $t('components.payout.amount') }}</th>
            <th>{{ $t('components.payout.fee') }}</th>
            <th>{{ $t('components.payout.net') }}</th>
            <th>{{ $t('components.payout.order') }}</th>
        </tr>
        </thead>
        <tbody>
        <PayoutTransactionRow
            :payout-transaction="payoutTransaction"
            v-for="payoutTransaction in payoutTransactions"
            v-bind:key="payoutTransaction.id"
        ></PayoutTransactionRow>
        </tbody>
    </table>
</template>

<script>

import PayoutTransactionRow from "./PayoutTransactionRow";

export default {
    name: "PayoutsTable",
    components: {PayoutTransactionRow},
    props: {
        payoutTransactions: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>